export default [
  {
    path: '/',
    name: 'home',
    component: () => import('./ViewHome.vue'),
  },
];
